import React, { useState, useEffect } from 'react';
import Carousel from 'react-material-ui-carousel';
import {Button, Divider} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Green from './img/sustainable.jpg';
import Illus from './img/illus.jpg';
import Burn from './img/burn.jpg';
import Burner from './img/slider/charity.jpg';
import Bg from './img/pellets_1.jpg';
import Energy from './img/energy.jpg';
import form1 from './3AM_FORMS.pdf';
import form2 from './3AM_Liability.pdf';
import Para0 from './img/slider/image1.jpg';
import Para1 from './img/slider/image.jpg';
import MissionGhanaFlyer from './img/mission-ghana-2027-flyer.jpeg';
import Pic1 from './img/trip/2022.jpg';
import Pic2 from './img/trip/give1.jpg';
import Pic3 from './img/trip/ethio4.jpg';
import Pic4 from './img/trip/give3.jpg';
import Pic5 from './img/trip/kenya.jpg';
import Pic6 from './img/trip/2022_0.jpg';
import Pic9 from './img/FB_IMG_1689787670548.jpg';
import Pict from './img/trip/tanzania.jpeg';
import Para3 from './img/slide3.jpeg';
import UserImage from './img/image.jpg';
import Grid from '@material-ui/core/Grid';
import { Parallax } from "react-parallax";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import itemData from './data';
import Typography from '@material-ui/core/Typography';
import Vid from './videos/churchbuilding.mp4';
import Vid2 from './videos/Schoolbuilding.mp4';
import Vid1 from './videos/tanzania.mp4';
import imager from './img/outreach.png';
import Community from './img/slider/community.svg';
import Evangelism from './img/slider/evengelism.svg';
import Medical from './img/slider/medical.svg';
import AOS from 'aos';
import "aos/dist/aos.css";
import Carousel_ from 'react-grid-carousel'

import ButtonBase from '@material-ui/core/ButtonBase';
import  {
  Link
} from 'react-router-dom';
import { mapsEmbedUrl, mailingAddress, mapsLink } from './sharedStyles';

const useStyles = makeStyles((theme) => ({
  // Hero Section Styles
  heroSection: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, rgba(44, 62, 80, 0.75) 0%, rgba(74, 144, 226, 0.55) 50%, rgba(97, 218, 251, 0.45) 100%), url(${UserImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      backgroundAttachment: 'scroll',
      minHeight: '90vh',
    },
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'radial-gradient(ellipse at center, rgba(44,62,80,0.3) 0%, rgba(44,62,80,0.65) 100%)',
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
    maxWidth: 860,
    padding: '80px 20px 100px',
  },
  heroBadge: {
    display: 'inline-block',
    background: 'rgba(255,255,255,0.12)',
    border: '1px solid rgba(255,215,0,0.35)',
    borderRadius: 50,
    padding: '8px 22px',
    fontSize: '0.8rem',
    fontWeight: 600,
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: '#FFD700',
    marginBottom: '1.5rem',
    backdropFilter: 'blur(8px)',
  },
  heroTitle: {
    fontSize: '3rem',
    fontWeight: 700,
    marginBottom: '1rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.8rem',
      lineHeight: 1.2,
    },
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    fontWeight: 300,
    marginBottom: '2rem',
    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.1rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      lineHeight: 1.4,
    },
  },
  heroButton: {
    background: 'linear-gradient(45deg, #61DAFB 30%, #FFD700 90%)',
    border: 0,
    borderRadius: 25,
    boxShadow: '0 3px 5px 2px rgba(97, 218, 251, .3)',
    color: '#2C3E50',
    height: 48,
    padding: '0 30px',
    fontSize: '1.1rem',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 10px 2px rgba(97, 218, 251, .4)',
    },
  },
  heroButtonOutline: {
    border: '2px solid rgba(255,255,255,0.7)',
    borderRadius: 25,
    color: 'white',
    height: 48,
    padding: '0 28px',
    fontSize: '1.05rem',
    fontWeight: 600,
    textTransform: 'none',
    background: 'rgba(255,255,255,0.08)',
    backdropFilter: 'blur(8px)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(255,255,255,0.18)',
      border: '2px solid #FFD700',
      transform: 'translateY(-2px)',
    },
  },
  heroActions: {
    display: 'flex',
    gap: '14px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: '2rem',
  },
  heroScrollHint: {
    position: 'absolute',
    bottom: 28,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    color: 'rgba(255,255,255,0.65)',
    fontSize: '0.75rem',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    '&:hover': {
      color: '#FFD700',
    },
  },
  scrollChevron: {
    width: 24,
    height: 24,
    borderRight: '2px solid rgba(255,215,0,0.7)',
    borderBottom: '2px solid rgba(255,215,0,0.7)',
    transform: 'rotate(45deg)',
    animation: '$bounceDown 2s ease-in-out infinite',
  },
  '@keyframes bounceDown': {
    '0%, 100%': { transform: 'rotate(45deg) translateY(0)' },
    '50%': { transform: 'rotate(45deg) translateY(6px)' },
  },

  // Impact stats bar
  statsBar: {
    background: 'transparent',
    padding: '0 0 48px',
    marginTop: -48,
    position: 'relative',
    zIndex: 3,
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 0,
    background: 'white',
    borderRadius: 20,
    boxShadow: '0 16px 48px rgba(44,62,80,0.12)',
    border: '1px solid rgba(97,218,251,0.15)',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
  statItem: {
    padding: '28px 20px',
    textAlign: 'center',
    borderRight: '1px solid rgba(97,218,251,0.12)',
    transition: 'background 0.3s ease',
    '&:last-child': { borderRight: 'none' },
    '&:hover': { background: 'rgba(232,244,253,0.5)' },
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
      borderBottom: '1px solid rgba(97,218,251,0.12)',
      '&:nth-child(odd)': { borderRight: '1px solid rgba(97,218,251,0.12)' },
      '&:nth-last-child(-n+2)': { borderBottom: 'none' },
    },
  },
  statNumber: {
    fontSize: '2rem',
    fontWeight: 800,
    color: '#2C3E50',
    lineHeight: 1,
    marginBottom: 6,
    '& span': { color: '#FFD700' },
  },
  statLabel: {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: '#7f8c8d',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },

  // Section header helpers
  sectionEyebrow: {
    display: 'inline-block',
    fontSize: '0.8rem',
    fontWeight: 700,
    letterSpacing: '2.5px',
    textTransform: 'uppercase',
    color: '#4A90E2',
    marginBottom: '0.75rem',
  },
  sectionSubtitle: {
    color: '#7f8c8d',
    fontWeight: 300,
    marginTop: '1rem',
    maxWidth: 560,
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: 1.7,
  },
  sectionTitleLight: {
    color: 'white',
    '&::after': {
      background: 'linear-gradient(45deg, #FFD700, #61DAFB)',
    },
  },

  // Section Styles
  section: {
    padding: '80px 0',
    [theme.breakpoints.down('md')]: {
      padding: '60px 0',
    },
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: '#2c3e50',
    position: 'relative',
    '&::after': {
      content: '""',
    position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: '4px',
      background: 'linear-gradient(45deg, #61DAFB, #FFD700)',
      borderRadius: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },

  // Card Styles
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
    },
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9 aspect ratio
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardContent: {
    flexGrow: 1,
    padding: '24px',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '1rem',
    color: '#2c3e50',
  },
  cardText: {
    color: '#7f8c8d',
    lineHeight: 1.6,
  },

  // Project Section
  projectSection: {
    background: 'linear-gradient(135deg, #E8F4FD 0%, #D1E9FB 100%)',
    padding: '80px 0',
  },
  projectCard: {
    background: 'white',
    borderRadius: 16,
    padding: '30px',
    boxShadow: '0 8px 32px rgba(97, 218, 251, 0.15)',
    transition: 'all 0.3s ease',
    height: '100%',
    border: '1px solid rgba(97, 218, 251, 0.1)',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 16px 48px rgba(97, 218, 251, 0.25)',
      border: '1px solid rgba(97, 218, 251, 0.3)',
    },
  },
  projectTitle: {
    fontSize: '1.8rem',
    fontWeight: 600,
    color: '#2c3e50',
    marginBottom: '1.5rem',
  },
  projectList: {
    color: '#34495e',
    lineHeight: 1.8,
    '& li': {
      marginBottom: '1rem',
      paddingLeft: '1rem',
    },
  },

  // Donate Button
  donateButton: {
    background: 'linear-gradient(45deg, #61DAFB 30%, #FFD700 90%)',
    borderRadius: 16,
    padding: '20px',
    textAlign: 'center',
    color: '#2C3E50',
    textDecoration: 'none',
    display: 'block',
    transition: 'all 0.3s ease',
    fontWeight: 600,
    '&:hover': {
      transform: 'scale(1.02)',
      textDecoration: 'none',
      color: '#2C3E50',
      boxShadow: '0 8px 32px rgba(97, 218, 251, 0.4)',
    },
  },
  donateText: {
    fontSize: '2rem',
    fontWeight: 700,
    margin: 0,
  },

  // Gallery Section
  gallerySection: {
    background: 'linear-gradient(135deg, #F8FBFF 0%, #E8F4FD 100%)',
    padding: '80px 0',
  },
  galleryTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: '#2c3e50',
  },
  galleryCard: {
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 28px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 16px 40px rgba(0,0,0,0.15)',
    },
  },
  galleryImageWrap: {
    position: 'relative',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      display: 'block',
      aspectRatio: '4/3',
      objectFit: 'cover',
      transition: 'transform 0.4s ease',
    },
    '&:hover img': {
      transform: 'scale(1.05)',
    },
  },
  galleryCaption: {
    padding: '14px 16px',
    background: 'white',
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#2C3E50',
    borderTop: '3px solid #FFD700',
  },
  galleryWrapper: {
    background: 'white',
    borderRadius: 20,
    padding: '24px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    border: '1px solid rgba(97,218,251,0.1)',
  },

  // Video Section
  videoSection: {
    padding: '80px 0',
    background: 'white',
  },
  videoCard: {
    background: 'white',
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 16px 48px rgba(0,0,0,0.15)',
    },
  },
  videoTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#2c3e50',
    textAlign: 'center',
    padding: '20px',
    margin: 0,
  },

  // Services Section
  servicesSection: {
    background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
    padding: '80px 0',
    color: 'white',
  },
  serviceCard: {
    background: 'rgba(255,255,255,0.1)',
    borderRadius: 16,
    padding: '30px',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    height: '100%',
    border: '1px solid rgba(255,255,255,0.2)',
    '&:hover': {
      transform: 'translateY(-8px)',
      background: 'rgba(255,255,255,0.15)',
      border: '1px solid rgba(255, 215, 0, 0.3)',
    },
  },
  serviceIcon: {
    width: '80px',
    height: '80px',
    margin: '0 auto 20px',
    // filter: 'brightness(0) invert(1)',
  },
  serviceTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '1rem',
    color: 'white',
  },
  serviceText: {
    color: 'rgba(255,255,255,0.9)',
    lineHeight: 1.6,
  },

  // Map Section
  mapSection: {
    padding: '80px 0',
    background: 'linear-gradient(135deg, #E8F4FD 0%, #D1E9FB 100%)',
  },
  mapContainer: {
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(97, 218, 251, 0.15)',
    border: '1px solid rgba(97, 218, 251, 0.1)',
  },
  mapLayout: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.6fr',
    gap: 32,
    alignItems: 'stretch',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  mapInfo: {
    background: 'white',
    borderRadius: 16,
    padding: '36px 32px',
    boxShadow: '0 8px 32px rgba(97,218,251,0.12)',
    border: '1px solid rgba(97,218,251,0.1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  mapInfoItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
    marginBottom: 24,
    '&:last-child': { marginBottom: 0 },
  },
  mapInfoIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: 'linear-gradient(135deg, #E8F4FD, #D1E9FB)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem',
    flexShrink: 0,
  },
  mapInfoLabel: {
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: '#4A90E2',
    marginBottom: 4,
  },
  mapInfoValue: {
    fontSize: '1rem',
    color: '#2C3E50',
    lineHeight: 1.5,
    '& a': {
      color: '#2C3E50',
      textDecoration: 'none',
      '&:hover': { color: '#4A90E2' },
    },
  },

  // CTA band
  ctaBand: {
    background: 'linear-gradient(135deg, #2C3E50 0%, #4A90E2 60%, #61DAFB 100%)',
    padding: '72px 0',
    textAlign: 'center',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -80,
      right: -80,
      width: 300,
      height: 300,
      borderRadius: '50%',
      background: 'rgba(255,215,0,0.06)',
    },
  },
  ctaTitle: {
    fontSize: '2.2rem',
    fontWeight: 700,
    marginBottom: '1rem',
    position: 'relative',
    [theme.breakpoints.down('sm')]: { fontSize: '1.75rem' },
  },
  ctaText: {
    fontSize: '1.1rem',
    color: 'rgba(255,255,255,0.85)',
    maxWidth: 520,
    margin: '0 auto 2rem',
    lineHeight: 1.7,
    position: 'relative',
  },
  ctaActions: {
    display: 'flex',
    gap: 14,
    flexWrap: 'wrap',
    justifyContent: 'center',
    position: 'relative',
  },

  // Responsive adjustments
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 20px',
  },

  // Countdown Timer Styles
  countdownSection: {
    padding: '80px 0',
    background: `linear-gradient(160deg, rgba(13,40,24,0.82) 0%, rgba(26,58,42,0.78) 40%, rgba(44,62,80,0.85) 100%), url(${MissionGhanaFlyer})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      backgroundAttachment: 'scroll',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 6,
      background: 'linear-gradient(90deg, #CE1126 33.33%, #FFD700 33.33% 66.66%, #006B3F 66.66%)',
      zIndex: 2,
    },
  },
  countdownContent: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
  },
  countdownBadge: {
    display: 'inline-block',
    background: 'rgba(206, 17, 38, 0.25)',
    border: '1px solid rgba(255, 215, 0, 0.4)',
    borderRadius: 50,
    padding: '8px 24px',
    fontSize: '0.85rem',
    fontWeight: 600,
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: '#FFD700',
    marginBottom: '1.5rem',
  },
  countdownTitle: {
    fontSize: '3rem',
    fontWeight: 700,
    marginBottom: '0.75rem',
    color: '#FFD700',
    textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  countdownSubtitle: {
    fontSize: '1.2rem',
    fontWeight: 300,
    marginBottom: '2.5rem',
    color: 'rgba(255,255,255,0.9)',
    textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
  },
  countdownInfoPanel: {
    maxWidth: 640,
    margin: '0 auto',
    padding: '32px',
    background: 'rgba(0,0,0,0.45)',
    borderRadius: 20,
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(255,255,255,0.12)',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 20px',
    },
  },
  countdownWrapper: {
    maxWidth: 720,
    margin: '0 auto 2.5rem',
    padding: '36px 28px 32px',
    background: 'rgba(0,0,0,0.5)',
    borderRadius: 24,
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.12)',
    boxShadow: '0 24px 60px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.08)',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '28px 16px 24px',
      borderRadius: 20,
    },
  },
  countdownWrapperLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '3px',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.55)',
    marginBottom: '1.75rem',
  },
  countdownGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      gap: '2px',
    },
  },
  countdownItem: {
    flex: '1 1 0',
    maxWidth: 120,
    background: 'rgba(0,0,0,0.25)',
    borderRadius: 16,
    padding: '20px 12px 16px',
    textAlign: 'center',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(255,255,255,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: '14px 6px 12px',
      borderRadius: 12,
      maxWidth: 80,
    },
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 32px rgba(0,0,0,0.3)',
    },
  },
  countdownItemRed: {
    borderTop: '3px solid #CE1126',
    '&:hover': { borderColor: 'rgba(206, 17, 38, 0.5)' },
  },
  countdownItemGold: {
    borderTop: '3px solid #FFD700',
    '&:hover': { borderColor: 'rgba(255, 215, 0, 0.5)' },
  },
  countdownItemGreen: {
    borderTop: '3px solid #006B3F',
    '&:hover': { borderColor: 'rgba(0, 107, 63, 0.5)' },
  },
  countdownItemPulse: {
    animation: '$countdownPulse 1s ease-in-out infinite',
  },
  countdownNumber: {
    fontSize: '2.75rem',
    fontWeight: 800,
    color: '#FFFFFF',
    marginBottom: '6px',
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1,
    textShadow: '0 2px 8px rgba(0,0,0,0.4)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.75rem',
    },
  },
  countdownNumberTick: {
    animation: '$countdownTick 0.35s ease-out',
  },
  countdownLabel: {
    fontSize: '0.7rem',
    fontWeight: 600,
    color: 'rgba(255,255,255,0.65)',
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem',
      letterSpacing: '1px',
    },
  },
  countdownSeparator: {
    fontSize: '2rem',
    fontWeight: 300,
    color: 'rgba(255,215,0,0.5)',
    padding: '0 2px',
    alignSelf: 'flex-start',
    marginTop: '18px',
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
      marginTop: '12px',
      padding: '0 1px',
    },
  },
  countdownProgress: {
    marginTop: '1.75rem',
    paddingTop: '1.5rem',
    borderTop: '1px solid rgba(255,255,255,0.08)',
  },
  countdownProgressBar: {
    height: 6,
    borderRadius: 3,
    background: 'rgba(255,255,255,0.1)',
    overflow: 'hidden',
    marginBottom: '10px',
  },
  countdownProgressFill: {
    height: '100%',
    borderRadius: 3,
    background: 'linear-gradient(90deg, #CE1126, #FFD700, #006B3F)',
    transition: 'width 1s ease',
  },
  countdownProgressText: {
    fontSize: '0.8rem',
    color: 'rgba(255,255,255,0.5)',
    letterSpacing: '0.5px',
  },
  countdownCtaRow: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: '1.5rem',
  },
  countdownCtaPrimary: {
    background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
    border: 0,
    borderRadius: 25,
    boxShadow: '0 6px 20px rgba(255, 215, 0, 0.3)',
    color: '#2C3E50',
    height: 48,
    padding: '0 24px',
    fontSize: '0.95rem',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
    },
  },
  countdownCtaSecondary: {
    border: '2px solid rgba(255,215,0,0.6)',
    color: '#FFD700',
    borderRadius: 25,
    height: 48,
    padding: '0 24px',
    fontSize: '0.95rem',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(255,215,0,0.12)',
      border: '2px solid #FFD700',
      transform: 'translateY(-2px)',
    },
  },
  '@keyframes countdownPulse': {
    '0%, 100%': { boxShadow: '0 0 0 0 rgba(255,215,0,0)' },
    '50%': { boxShadow: '0 0 20px 2px rgba(255,215,0,0.15)' },
  },
  '@keyframes countdownTick': {
    '0%': { transform: 'translateY(-6px)', opacity: 0.3 },
    '100%': { transform: 'translateY(0)', opacity: 1 },
  },

  // Advertising Section Styles
  advertisingSection: {
    padding: '80px 0',
    background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
    position: 'relative',
    overflow: 'hidden',
  },
  advertisingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      textAlign: 'center',
      gap: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      gap: '20px',
    },
  },
  advertisingImage: {
    flex: '0 0 400px',
    borderRadius: 20,
    overflow: 'hidden',
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
    border: '3px solid rgba(255,255,255,0.2)',
    [theme.breakpoints.down('md')]: {
      flex: '0 0 auto',
    width: '100%',
      maxWidth: '400px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '300px',
      borderRadius: 15,
    },
  },
  advertisingContent: {
    flex: 1,
    color: 'white',
  },
  advertisingTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: '1rem',
    color: '#FFD700',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  advertisingText: {
    fontSize: '1.1rem',
    lineHeight: 1.8,
    marginBottom: '2rem',
    color: 'rgba(255,255,255,0.9)',
  },
  advertisingButton: {
    background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
    border: 0,
    borderRadius: 25,
    boxShadow: '0 6px 20px rgba(255, 215, 0, 0.3)',
    color: '#2C3E50',
    height: 50,
    padding: '0 30px',
    fontSize: '1.1rem',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
    },
  },
}));

const MISSION_GHANA_DATE = new Date('May 11, 2027 00:00:00').getTime();
const MISSION_JOURNEY_START = new Date('January 1, 2026 00:00:00').getTime();

const padTime = (value) => String(value).padStart(2, '0');

const COUNTDOWN_UNITS = [
  { key: 'days', label: 'Days', accent: 'countdownItemRed' },
  { key: 'hours', label: 'Hours', accent: 'countdownItemGold' },
  { key: 'minutes', label: 'Minutes', accent: 'countdownItemGreen' },
  { key: 'seconds', label: 'Seconds', accent: 'countdownItemGold', pulse: true },
];

// Countdown Timer Component
const CountdownTimer = () => {
  const classes = useStyles();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [progress, setProgress] = useState(0);
  const [secondsTick, setSecondsTick] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const updateTimer = () => {
      const now = Date.now();
      const difference = MISSION_GHANA_DATE - now;

      if (difference > 0) {
        setHasStarted(false);
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });

        const totalJourney = MISSION_GHANA_DATE - MISSION_JOURNEY_START;
        const elapsed = now - MISSION_JOURNEY_START;
        setProgress(Math.min(100, Math.max(0, (elapsed / totalJourney) * 100)));
      } else {
        setHasStarted(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setProgress(100);
      }
    };

    updateTimer();
    const timer = setInterval(() => {
      setSecondsTick(true);
      updateTimer();
      setTimeout(() => setSecondsTick(false), 350);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const downloadForm = (href, filename) => {
    try {
      const link = document.createElement('a');
      link.href = href;
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      window.open(href, '_blank');
    }
  };

  if (hasStarted) {
    return (
      <div className={classes.countdownWrapper} data-aos="fade-up" data-aos-delay="100">
        <Typography className={classes.countdownWrapperLabel}>
          Mission Ghana 2027
        </Typography>
        <Typography variant="h4" style={{ color: '#FFD700', fontWeight: 700, marginBottom: '0.5rem' }}>
          The Mission Has Begun!
        </Typography>
        <Typography style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1rem' }}>
          Discover Hope 2027 is underway in Ghana. Join us in prayer and support.
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.countdownWrapper} data-aos="fade-up" data-aos-delay="100">
      <Typography className={classes.countdownWrapperLabel}>
        Countdown to Mission Day
      </Typography>

      <div className={classes.countdownGrid}>
        {COUNTDOWN_UNITS.map((unit, index) => (
          <React.Fragment key={unit.key}>
            {index > 0 && (
              <span className={classes.countdownSeparator} aria-hidden="true">:</span>
            )}
            <div
              className={[
                classes.countdownItem,
                classes[unit.accent],
                unit.pulse ? classes.countdownItemPulse : '',
              ].join(' ')}
            >
              <div
                className={[
                  classes.countdownNumber,
                  unit.key === 'seconds' && secondsTick ? classes.countdownNumberTick : '',
                ].join(' ')}
              >
                {padTime(timeLeft[unit.key])}
              </div>
              <div className={classes.countdownLabel}>{unit.label}</div>
            </div>
          </React.Fragment>
        ))}
      </div>

      <div className={classes.countdownProgress}>
        <div className={classes.countdownProgressBar}>
          <div
            className={classes.countdownProgressFill}
            style={{ width: `${progress}%` }}
          />
        </div>
        <Typography className={classes.countdownProgressText}>
          {timeLeft.days} days until we depart · May 11, 2027
        </Typography>
      </div>

      <div className={classes.countdownCtaRow}>
        <Button
          variant="contained"
          className={classes.countdownCtaPrimary}
          onClick={() => downloadForm(form1, '3AM_Registration_Form.pdf')}
        >
          Download Registration Form
        </Button>
        <Button
          variant="outlined"
          className={classes.countdownCtaSecondary}
          onClick={() => downloadForm(form2, '3AM_Liability_Form.pdf')}
        >
          Download Liability Form
        </Button>
      </div>
    </div>
  );
};

// Impact stats bar
const IMPACT_STATS = [
  { number: '15+', label: 'Countries Reached' },
  { number: '10+', label: 'Years of Service' },
  { number: '3', label: 'Core Ministries' },
  { number: '2027', label: 'Mission Ghana' },
];

const ImpactStatsBar = () => {
  const classes = useStyles();
  return (
    <div className={classes.statsBar}>
      <div className={classes.container}>
        <div className={classes.statsGrid} data-aos="fade-up">
          {IMPACT_STATS.map((stat) => (
            <div key={stat.label} className={classes.statItem}>
              <div className={classes.statNumber}>{stat.number}</div>
              <div className={classes.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

// Mission Ghana 2027 Section
const MissionGhanaSection = () => {
  const classes = useStyles();

  return (
    <section id="mission-ghana" className={classes.countdownSection}>
      <div className={classes.container}>
        <div className={classes.countdownContent}>
          <div className={classes.countdownBadge} data-aos="fade-down">
            Discover Hope 2027
          </div>
          <Typography variant="h2" className={classes.countdownTitle} data-aos="fade-up">
            Mission Ghana 2027
          </Typography>
          <Typography variant="h5" className={classes.countdownSubtitle} data-aos="fade-up">
            May 11–22, 2027 · Accra, Ghana
          </Typography>

          <CountdownTimer />

          <div className={classes.countdownInfoPanel} data-aos="fade-up">
            <Typography variant="body1" className={classes.advertisingText} style={{ marginBottom: '1.25rem' }}>
              3AM Mission Ministry, in partnership with the South Central Ghana Conference
              of the Seventh-Day Adventist Church, invites you to a lifetime opportunity to
              advance the gospel commission in Africa.
            </Typography>
            <Typography variant="body1" className={classes.advertisingText} style={{ marginBottom: '1.25rem' }}>
              All interested in spreading the gospel of Jesus and sharing His love are welcome.
              Activities include evangelistic & health messages, medical and community outreach.
            </Typography>
            <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.8)' }}>
              Contact: support@3ammissionministry.com · www.3ammissionministry.com
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
};

const GALLERY_ITEMS = [
  { src: Pict, caption: 'Community Outreach In Tanzania (2024)' },
  { src: Pic1, caption: 'Evangelism In Madagascar' },
  { src: Pic2, caption: 'Community Outreach In Ghana' },
  { src: Pic3, caption: 'Evangelism in Ethiopia' },
  { src: Pic4, caption: 'Community Outreach In India' },
  { src: Pic5, caption: 'Community Outreach In Kenya' },
  { src: Pic6, caption: 'Evangelism In Madagascar' },
];

const Caroo = () => {
  const classes = useStyles();
  return (
    <Carousel_ cols={3} rows={1} gap={20} autoplay={4000} loop>
      {GALLERY_ITEMS.map((item) => (
        <Carousel_.Item key={item.caption}>
          <div className={classes.galleryCard}>
            <div className={classes.galleryImageWrap}>
              <img src={item.src} alt={item.caption} />
            </div>
            <div className={classes.galleryCaption}>{item.caption}</div>
          </div>
        </Carousel_.Item>
      ))}
    </Carousel_>
  );
};

const Caro2 = () => {
  return (
    <Carousel_ cols={1} rows={1} gap={20} loop>
      
      
       <Carousel_.Item>
        <div style={{background: 'white', borderRadius: 16, padding: '20px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)'}}>
          <p style={{margin: '0 0 20px 0', fontSize: '1.5rem', textAlign: 'center', fontWeight: 600, color: '#2c3e50'}}>
            Church Building Project
          </p>
          <video src={Vid} controls width="100%" style={{borderRadius: 12}} />
        </div>
      </Carousel_.Item>

       <Carousel_.Item>
        <div style={{background: 'white', borderRadius: 16, padding: '20px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)'}}>
          <p style={{margin: '0 0 20px 0', fontSize: '1.5rem', textAlign: 'center', fontWeight: 600, color: '#2c3e50'}}>
            School Building Project
          </p>
          <video width="100%" src={Vid2} controls style={{borderRadius: 12}} />
        </div>
      </Carousel_.Item>
      
      <Carousel_.Item>
        <div style={{background: 'white', borderRadius: 16, padding: '20px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)'}}>
          <p style={{margin: '0 0 20px 0', fontSize: '1.5rem', textAlign: 'center', fontWeight: 600, color: '#2c3e50'}}>
            Mission Tanzania 2024
          </p>
          <iframe 
            src="https://drive.google.com/file/d/1Zs7cQGIh8g5b5V5k6XOLx2mSwn71zXzH/preview" 
            width="100%" 
            height="400" 
            style={{borderRadius: 12, border: 'none'}} 
            allow="autoplay"
          />
        </div>
      </Carousel_.Item>
      
    </Carousel_>
  );
};

function Example(props) {
  const classes = useStyles();

  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 100 });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className={classes.heroSection}>
        <div className={classes.heroOverlay} />
        <div className={classes.heroContent}>
          <div className={classes.heroBadge} data-aos="fade-down">
            Spreading Hope Worldwide
          </div>
          <Typography variant="h1" className={classes.heroTitle} data-aos="fade-up">
            <span style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              -3<span style={{ color: '#FFD700', textShadow: '2px 2px 4px rgba(255, 215, 0, 0.3)' }}>AM</span> Mission Ministry-
            </span>
          </Typography>
          <Typography variant="h4" className={classes.heroSubtitle} data-aos="fade-up" data-aos-delay="150">
            Let's Reach Out To The World
          </Typography>
          <Typography variant="body1" style={{ color: 'rgba(255,255,255,0.8)', maxWidth: 540, margin: '0 auto', lineHeight: 1.7 }} data-aos="fade-up" data-aos-delay="200">
            Evangelism, community outreach, and medical missions — bringing the gospel and practical help to communities across the globe.
          </Typography>
          <div className={classes.heroActions} data-aos="fade-up" data-aos-delay="300">
            <Button
              variant="contained"
              className={classes.heroButton}
              onClick={() => scrollToSection('mission-ghana')}
            >
              Mission Ghana 2027
            </Button>
            <Button
              variant="outlined"
              className={classes.heroButtonOutline}
              component={Link}
              to="/donate"
            >
              Support Our Mission
            </Button>
          </div>
        </div>
        <div
          className={classes.heroScrollHint}
          onClick={() => scrollToSection('mission-ghana')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && scrollToSection('mission-ghana')}
          aria-label="Scroll to Mission Ghana section"
        >
          <span>Explore</span>
          <div className={classes.scrollChevron} />
        </div>
      </section>

      <ImpactStatsBar />

      {/* Mission Ghana 2027 Countdown */}
      <MissionGhanaSection />

      {/* Projects Section */}
      <section className={classes.projectSection}>
        <div className={classes.container}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }} data-aos="fade-up">
            <Typography className={classes.sectionEyebrow}>What We're Building</Typography>
            <Typography variant="h2" className={classes.sectionTitle}>
              Our Current Projects
            </Typography>
            <Typography variant="h6" className={classes.sectionSubtitle}>
              Building communities and spreading hope worldwide
            </Typography>
          </div>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="100">
              <div style={{
                background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
                borderRadius: 20,
                padding: '40px',
                height: '100%',
                color: 'white',
                boxShadow: '0 20px 40px rgba(97, 218, 251, 0.2)',
                border: '1px solid rgba(255,255,255,0.1)',
                position: 'relative',
                overflow: 'hidden',
              }}>
                <div style={{
                  position: 'absolute',
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '50%',
                  zIndex: 0,
                }}></div>
                <div style={{position: 'relative', zIndex: 1}}>
                  <Typography variant="h4" style={{fontWeight: 700, marginBottom: '2rem', color: '#FFD700'}}>
                    🏗️ Project Description
                  </Typography>
                  <ol style={{
                    listStyle: 'none',
                    padding: 0,
                    counterReset: 'project-counter',
                  }}>
                    <li style={{
                      counterIncrement: 'project-counter',
                      marginBottom: '1.5rem',
                      padding: '20px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: 12,
                      borderLeft: '4px solid #FFD700',
                      position: 'relative',
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: '20px',
                        left: '-10px',
                        background: '#FFD700',
                        color: '#2C3E50',
                        borderRadius: '50%',
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 700,
                      }}>
                        {String.fromCharCode(65 + 0)}
                      </div>
                      <div style={{marginLeft: '20px'}}>
                        We are building 3 additional classrooms, an office for principal, desks and benches, improve toilets and add an overhead water tank to collect rain water for daily use at SDA Elementary School in the district of Infanadiana in Madagascar
                      </div>
                    </li>
                    <li style={{
                      counterIncrement: 'project-counter',
                      marginBottom: '1.5rem',
                      padding: '20px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: 12,
                      borderLeft: '4px solid #FFD700',
                      position: 'relative',
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: '20px',
                        left: '-10px',
                        background: '#FFD700',
                        color: '#2C3E50',
                        borderRadius: '50%',
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 700,
                      }}>
                        {String.fromCharCode(65 + 1)}
                      </div>
                      <div style={{marginLeft: '20px'}}>
                        We are building a new church for the SDA church at Antadinambo in Madagascar which has a little building to accommodate church members.
                      </div>
                    </li>
                  </ol>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="200">
              <Link to="/donate" style={{textDecoration: 'none', display: 'block', height: '100%'}}>
                <div style={{
                  background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
                  borderRadius: 20,
                  padding: '40px',
                  height: '100%',
                  color: '#2C3E50',
                  boxShadow: '0 20px 40px rgba(255, 215, 0, 0.3)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden',
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-10px)';
                  e.target.style.boxShadow = '0 30px 60px rgba(255, 215, 0, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 20px 40px rgba(255, 215, 0, 0.3)';
                }}>
                  <div style={{
                    fontSize: '4rem',
                    marginBottom: '1rem',
                  }}>
                    💝
                  </div>
                  <Typography variant="h3" style={{fontWeight: 700, marginBottom: '1rem'}}>
                    Donate Here
            </Typography>
                  <Typography variant="body1" style={{marginBottom: '2rem', opacity: 0.8}}>
                    Support our mission and make a difference
                  </Typography>
                  <div style={{
                    background: 'rgba(255,255,255,0.2)',
                    borderRadius: 25,
                    padding: '12px 30px',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    border: '2px solid rgba(255,255,255,0.3)',
                  }}>
                    Click to Donate
                  </div>
                </div>
</Link>            
         </Grid>
        </Grid>
        </div>
      </section>

      {/* Video Section */}
      <section className={classes.videoSection}>
        <div className={classes.container}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }} data-aos="fade-up">
            <Typography className={classes.sectionEyebrow}>Watch & Learn</Typography>
            <Typography variant="h2" className={classes.sectionTitle}>
              Our Mission Videos
            </Typography>
            <Typography variant="h6" className={classes.sectionSubtitle}>
              See our work in action around the world
            </Typography>
          </div>
          <div style={{
            maxWidth: 800, 
            margin: '0 auto',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: 20,
            padding: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
          }}>
            <Caro2 />
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className={classes.gallerySection}>
        <div className={classes.container}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }} data-aos="fade-up">
            <Typography className={classes.sectionEyebrow}>Around the World</Typography>
            <Typography variant="h2" className={classes.galleryTitle}>
              Our Global Impact
            </Typography>
            <Typography variant="h6" className={classes.sectionSubtitle}>
              Our borders are extended throughout the World
            </Typography>
          </div>

          <div className={classes.galleryWrapper} data-aos="fade-up">
            <Caroo />
          </div>
          
          <div style={{
            textAlign: 'center',
            background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
            borderRadius: 20,
            padding: '40px',
            boxShadow: '0 20px 40px rgba(97, 218, 251, 0.2)',
          }} data-aos="fade-up">
            <Typography variant="h4" style={{color: 'white', fontWeight: 700, marginBottom: '1rem'}}>
              🌍 Global Outreach
            </Typography>
            <Typography variant="body1" style={{color: 'rgba(255,255,255,0.9)', marginBottom: '2rem'}}>
              We've made an impact across the globe
            </Typography>
            <img 
              src={imager} 
              width="100%" 
              style={{
                maxWidth: 800, 
                borderRadius: 12, 
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                border: '3px solid rgba(255,255,255,0.2)',
              }} 
            />
    </div>
        </div>
      </section>

      {/* Services Section */}
      <section className={classes.servicesSection}>
        <div className={classes.container}>
          <div style={{ textAlign: 'center' }} data-aos="fade-up">
            <Typography className={classes.sectionEyebrow} style={{ color: '#FFD700' }}>
              Our Ministries
            </Typography>
            <Typography variant="h2" className={`${classes.sectionTitle} ${classes.sectionTitleLight}`}>
              What We Do
            </Typography>
            <Typography variant="h6" style={{ color: 'rgba(255,255,255,0.8)', fontWeight: 300, marginTop: '1rem', maxWidth: 520, marginLeft: 'auto', marginRight: 'auto' }}>
              Three pillars guiding every mission trip and outreach
            </Typography>
          </div>
          
          <Grid container spacing={4} style={{marginTop: 40}}>
            <Grid item xs={12} md={4} data-aos="fade-up" data-aos-delay="100">
              <div className={classes.serviceCard}>
                <img src={Community} className={classes.serviceIcon} alt="Community Outreach" />
                <Typography variant="h5" className={classes.serviceTitle}>
          Community Outreach
          </Typography>
                <Typography variant="body1" className={classes.serviceText}>
                  This program is based on the Gospel of Jesus, Matthew 25: 42, 43 & 45 For I was hungry and you gave me no food, I was thirsty and you gave me no drink.
                </Typography>
              </div>
         </Grid> 

            <Grid item xs={12} md={4} data-aos="fade-up" data-aos-delay="200">
              <div className={classes.serviceCard}>
                <img src={Evangelism} className={classes.serviceIcon} alt="Evangelism" />
                <Typography variant="h5" className={classes.serviceTitle}>
          Evangelism
          </Typography>
                <Typography variant="body1" className={classes.serviceText}>
                  Go ye therefore, and make disciples of All Nations, baptizing them in the name of the Father and of the Son and the Holy Spirit. Matthew 28:18-20
                </Typography>
              </div>
         </Grid> 

            <Grid item xs={12} md={4} data-aos="fade-up" data-aos-delay="300">
              <div className={classes.serviceCard}>
                <img src={Medical} className={classes.serviceIcon} alt="Health and Medical Outreach" />
                <Typography variant="h5" className={classes.serviceTitle}>
          Health and Medical Outreach
          </Typography>
                <Typography variant="body1" className={classes.serviceText}>
                  We promote the 8 Bible Secrets for a longer and stronger life for an Amazing Health Benefits when we use The Newstart Lifestyle
                </Typography>
              </div>
         </Grid> 
        </Grid> 
    </div>
      </section>

      {/* CTA Band */}
      <section className={classes.ctaBand}>
        <div className={classes.container}>
          <Typography variant="h2" className={classes.ctaTitle} data-aos="fade-up">
            Ready to Make a Difference?
          </Typography>
          <Typography className={classes.ctaText} data-aos="fade-up" data-aos-delay="100">
            Join our next mission trip, support a project, or partner with us to spread hope to communities in need.
          </Typography>
          <div className={classes.ctaActions} data-aos="fade-up" data-aos-delay="200">
            <Button
              variant="contained"
              className={classes.heroButton}
              component={Link}
              to="/donate"
            >
              Donate Now
            </Button>
            <Button
              variant="outlined"
              className={classes.heroButtonOutline}
              component={Link}
              to="/contactus"
            >
              Contact Us
            </Button>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className={classes.mapSection}>
        <div className={classes.container}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }} data-aos="fade-up">
            <Typography className={classes.sectionEyebrow}>Find Us</Typography>
            <Typography variant="h2" className={classes.sectionTitle}>
              Visit Our Ministry
            </Typography>
          </div>
          <div className={classes.mapLayout} data-aos="fade-up">
            <div className={classes.mapInfo}>
              <div className={classes.mapInfoItem}>
                <div className={classes.mapInfoIcon}>📍</div>
                <div>
                  <div className={classes.mapInfoLabel}>Address</div>
                  <div className={classes.mapInfoValue}>
                    <a href={mapsLink} target="_blank" rel="noopener noreferrer">{mailingAddress}</a>
                  </div>
                </div>
              </div>
              <div className={classes.mapInfoItem}>
                <div className={classes.mapInfoIcon}>📧</div>
                <div>
                  <div className={classes.mapInfoLabel}>Email</div>
                  <div className={classes.mapInfoValue}>
                    <a href="mailto:support@3ammissionministry.com">support@3ammissionministry.com</a>
                  </div>
                </div>
              </div>
              <div className={classes.mapInfoItem}>
                <div className={classes.mapInfoIcon}>📞</div>
                <div>
                  <div className={classes.mapInfoLabel}>Phone</div>
                  <div className={classes.mapInfoValue}>
                    <a href="tel:+14438087618">+1 (443) 808-7618</a>
                  </div>
                </div>
              </div>
              <Button
                variant="contained"
                className={classes.heroButton}
                component="a"
                href={mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop: 8, alignSelf: 'flex-start' }}
              >
                Get Directions
              </Button>
            </div>
            <div className={classes.mapContainer}>
              <iframe
                src={mapsEmbedUrl}
                width="100%"
                height="400"
                style={{ border: 0, display: 'block' }}
                title="3AM Mission Ministry location"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function Item(props) {
  const classes = useStyles();
    return (
    <div 
      className={classes.heroSection} 
      style={{
        backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${props.item.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className={classes.heroOverlay}></div>
      <div className={classes.heroContent}>
        <Typography variant="h3" className={classes.heroSubtitle} data-aos="fade-up">
          {props.item.description}
        </Typography>
            {props.item.name} 
        <div style={{marginTop: '2rem'}} data-aos="fade-up" data-aos-delay="300">
          <Button 
            variant="contained" 
            className={classes.heroButton}
            component={Link}
            to="/donate"
          >
            Support Our Mission
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Example;


